<!--<app-sidenav *ngIf="defaultMyAccountServiceId" [defaultMyAccountServiceId]="defaultMyAccountServiceId"></app-sidenav>-->
<div class="service-content {{
		store.state.common.sidemenuSmall ? 'sidemenu-small' : ''
	}} container-fluid h-100" (keypress)="submitInput($event); $event.stopPropagation()">
	<div class="pl-md-5">
		<!-- Header -->
		<div class="list-header row">
			<div class="col mt-1">
				<tutorial-layer
						*ngIf="pageTutorials"
						title="{{ 'All services' | translate }}"
						isClosed="true"
						[editorData]="pageTutorials"
						(saveTutorial)="saveTutorial($event)">
				</tutorial-layer>
				<h1 class="list-header-title" *ngIf="!archived">
					{{ 'nav.services' | translate }}
				</h1>
				<h1 class="list-header-title" *ngIf="archived">
					{{ 'Archived services' | translate }}
				</h1>
			</div>
		</div>
		<!-- Search -->
		<div class="row mb-4">
			<div class="col-md-12 col-xl-12 col-xxl-10 align-content-center justify-content-end d-flex">
				<div class="list-search-container w-50 m-0">
					<i class="fas fa-search list-search-icon"></i>
					<input (click)="$event.stopPropagation()" (input)="searchTextChanged($event.target.value)"
						[(ngModel)]="searchValue" class="form-control list-search-input" placeholder="{{
							'Search or type to add a new service' | translate
						}}" type="text" />
					<i *ngIf="isNewServiceLoading"
						class="fa fa-spinner fa-spin services-select__remove services-select__icon mr-2" aria-hidden="true"></i>
					<i *ngIf="searchTextFilterObject && searchTextFilterObject.name" (click)="resetSearch()"
						class="fas fa-times btn-xs btn-bordered btn-danger btn-icon float-right nglist-item-action remove__icon mr-2"
						aria-hidden="true"></i>
				</div>
				<i tooltip="{{(showFilters ? 'Hide filters' : 'Show filters') | translate}}" placement="right"
					class="mx-4 my-2 far fa-bars-filter btn btn-md btn-icon {{showFilters ? 'btn-primary-light text-white' : ''}}" (click)="showFilters = !showFilters"></i>
				<div class="list-search-container ml-auto align-content-center justify-content-end pr-0 bg-transparent m-0">
					<service-file-uploader class="ml-auto" (fileIdChanged)="logoFileIdChanged($event)" (uploadInput)="logoFileIdChanged($event)" [serviceUrl]="'validate_catalogs'"
						[hideIcon]="true" buttonLabel="{{ 'Import' | translate }}" [simpleButton]="true"></service-file-uploader>
					<a (click)="createService()" class="btn btn-primary ml-2 text-white" placement="left"
						aria-hidden="true">{{ 'Add' | translate }}</a>
				</div>
			</div>
		</div>
		<!-- Listing -->
		<div *ngIf="!isServiceSelected()" class="expanded-list row" cdkDropListGroup>
			<div class="col-12 col-lg-12 col-xl-12 col-xxl-10">
				<div class="inner">
					<div class="row align-content-center bg-light py-2 rounded-lg" *ngIf="showFilters">
						<div class="col d-flex justify-content-start align-content-center">
							<ng-container *ngIf="allCategories && allCategories.length">
								<div class="categories-filters">
									<button type="button" class="categories-filters-item {{selectedCat === 'all' ? 'active' : ''}} btn btn-toggle btn-sm" (click)="filterByCategory('all');">{{ 'All' | translate }}</button>
									<button type="button" *ngFor="let cat of allCategories" class="categories-filters-item  {{cat.selected ? 'active' : ''}} btn btn-toggle btn-sm" (click)="filterByCategory(cat);">{{ cat.category }}</button>
								</div>
							</ng-container>
						</div>
						<div class="col-auto d-flex justify-content-end align-content-center align-items-center">
							<div class="toggle-small align-content-center d-flex align-items-center mr-4">
								<span style="position: relative;" class="{{showOnlyHighlightedServices ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle-disabled'}} fas toggle__icon mr-1"  (click)="showOnlyHighlightedServices = !showOnlyHighlightedServices"></span>
								 {{'Only show highlighted services' | translate}}
							</div>
							<div class="toggle-small align-content-center d-flex align-items-center mr-4" *ngIf="externals > 0">
								<span style="position: relative;" class="{{showExternalinList ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle-disabled'}} fas toggle__icon mr-1"  (click)="toggleAllExtinList()"></span>
								 {{'Show external servers' | translate}}
							</div>
							<div class="toggle-small align-content-center d-flex align-items-center mr-4">
								<span style="position: relative;" class="{{filteredUserServices ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle-disabled'}} fas toggle__icon mr-1"  (click)="filterUserServices()"></span>
								 {{'Show my services' | translate}}
							</div>
							<a href="/services/archived"  *ngIf="!archived" class="fad fa-box-archive text-primary" tooltip="{{ 'Archived services' | translate }}" placement="right"></a>
							<a href="/services"  *ngIf="archived" class="fad fa-circle-nodes" tooltip="{{ 'nav.services' | translate }}" placement="right"></a>
						</div>
					</div>
					<div *ngIf="servicesGroups && servicesGroups.length" class="row mt-3">
						<div class="col-12" 
							cdkDropList
							[cdkDropListData]="servicesGroups"
							(cdkDropListDropped)="droppedGroup($event)">
							<div *ngFor="let group of servicesGroups" class="{{group.status ? 'mb-3' : ''}}">
								<div cdkDrag [cdkDragDisabled]="!group.id" class="list-header row align-items-stretch" (click)="toggleGroupStatus(group)">
									<div class="col d-flex align-items-center service-list-header p-0">
										<span *ngIf="!group.loading" class="list-header-collapse-toggle">
											<i class="far fa-angle-{{group.status ? 'up' : 'down'}} btn-border btn-xs"></i>
										</span>
										<b class="list-header-title user-feedback">{{ group.id ? group.name : (group.name | translate) }}</b>
										<span *ngIf="!group.loading" class="ml-2 badge badge-light">{{ getVisibleServicesCount(group) }}</span>
										<i *ngIf="group.loading" class="ml-2 fad fa-spinner-third fa-spin"></i>
									</div>
									<div *cdkDragPreview class="col d-flex align-items-center p-0">
										<b class="list-header-title user-feedback">{{ group.id ? group.name : (group.name | translate) }}</b>
										<span *ngIf="!group.loading" class="ml-2 badge badge-light">{{ getVisibleServicesCount(group) }}</span>
									</div>
								<!--
									<div class="col-auto d-flex align-items-center">
										
									</div>
								-->
								</div>
								<div *ngIf="!group.loading" class="row" [class.mt-3]="group.status">
									<div class="col-12" *ngIf="group.services && group.services.length && group.status">
										<div class="row">

											<div class="col-4 d-flex align-items-center milli">{{ 'Edit service' | translate }}</div>
											<div class="col-6 x-bordered">
												<div class="row">
													<div class="col-4 milli">{{ 'See service' | translate }}</div>
													<div class="col-2 milli text-center">{{ 'Is active' | translate }}</div>
													<div class="col-4">
														<div class="row">
															<div class="col d-flex flex-row align-items-center cursor-pointer milli text-left" (click)="sortServices('lastPublishDate')">
																{{ 'Last published' | translate }}
																<i *ngIf="sortKey === 'lastPublishDate'" class="ml-auto fas {{
																	ascending ? 'fa-angle-up' : 'fa-angle-down'
																}}"></i>
															</div>
														</div>
													</div>
													<div class="col-2 milli flex-row align-items-center d-flex">{{ 'Version' | translate }}</div>
												</div>
											</div>
											<div class="col-2 text-right"></div>

										</div>
									</div>
									<div class="col-12">
													<div cdkDropList
													id="{{ 'service-group-' + group.id }}"
													[cdkDropListConnectedTo]="getAllGroupsExceptCurrent(group.id)"
													[cdkDropListData]="group.services || []"
													(cdkDropListDropped)="dropped($event, group)"
													class="services-drop-zone"
													[class.is-empty]="!group.services || !group.services.length"
													[class.is-collapsed]="!group.status"
													[class.drag-active]="dragInProgress">
										<ng-container *ngIf="group.status">
										<div cdkDrag [cdkDragData]="service"
												(cdkDragStarted)="onServiceDragStarted()"
												(cdkDragEnded)="onServiceDragEnded()"
												*ngFor="
												let service of group.services | expandedListFilter: (searchValue || filteredUser) | filterByCategory: isAcatSelected | sortBy:(ascending ? 'asc' : 'desc'):sortKey;
												let i = index;
												let first = first
												let last = last"
												class="list-item-container">
											<ng-container *ngIf="((showOnlyHighlightedServices && service.highlight) || !showOnlyHighlightedServices) && group.status">
												<div class="item row align-items-stretch {{ service.statusesInExternalServers?.length ? 'has-externals' : ''}} {{ last ? 'last' : '' }} {{ first ? 'first' : '' }} {{ isServiceHidden(service) ? 'hidden' : ''}}">
													<div class="col-4 d-flex align-items-center py-2" (click)="editService(service)" tooltip="{{'Edit service' | translate}}">
														<span class="service-name">{{ service.name }}</span>
														<i *ngIf="service.isMyAccountPage" class="fal fa-home text-primary ml-auto"></i>
														<i *ngIf="service.highlight" class="fas text-live fa-badge-check ml-auto"></i>
													</div>
													<div class="col-6 x-bordered d-flex flex-column align-items-stretch">
														<div class="row align-centent-center flex-grow-1 py-2">
															<div class="col-4 align-items-center d-flex">
																<ng-container *ngIf="service.active && ((service.lastPublishDate || service.lastPublishedWhen) && service.publishHistory)">
																	<a href="#" tooltip="{{'See service' | translate}}" placement="right" container="body"
																		(click)="goSeeService(service); $event.preventDefault();"
																		class="badge badge-live mr-2">{{ "locally" | translate }}</a>
																	<ng-container *ngIf="service.statusesInExternalServers?.length > 0">
																		<i *ngIf="!service.showExternalinList" (click)="toggleExtinList(service)" class="fad fa-angle-down"></i>
																		<i *ngIf="service.showExternalinList" (click)="toggleExtinList(service)" class="fad fa-angle-up"></i>
																	</ng-container>
																	<i class="fal fa-link-simple ml-auto mr-4 icon-faded"
																		style="font-size:0.9rem"
																		tooltip="{{'Copy Service link' | translate}}"
																		placement="right"
																		container="body"
																		(click)="goSeeService(service, null, true); $event.preventDefault();"></i>
																</ng-container>
															</div>
															<div class="col-2 align-items-center d-flex justify-content-center">
																<a (click)="
																		toggleOperational(service, null);
																		$event.stopPropagation()
																	" class="{{ showIconFor(service) }}" aria-hidden="true" tooltip="{{ 'Toggle activation' | translate }}"></a>
															</div>
															<div class="col-4 align-items-center d-flex">
																<div class="row align-items-center flex-nowrap publish-row">
																	<div class="col-auto d-flex flex-row mb-0 milli text-left align-items-center pr-0 pl-1">
																		<times-popover [item]="service"></times-popover>
																	</div>
																	<div class="col d-flex flex-column mb-0 milli text-left px-0">
																		<ng-container *ngIf="service.lastPublishDate || service.lastPublishedWhen">
																			<span class="item-author">{{
																				service.lastPublisher || service.lastPublishedBy
																				}}</span>
																			<strong class="item-date" placement="right" container="body"
																				tooltip="{{ (service.lastPublish?.date || service.lastPublishDate) | date: 'H:mm:ss' }}">{{
																				(service.lastPublish?.date || service.lastPublishDate) | date: 'dd-MM-yyyy'
																			}}</strong>
																		</ng-container>
																	</div>
																</div>
															</div>
															<div class="col-2 align-items-center d-flex" (click)="$event.preventDefault()">
																<i class="fad fa-spinner-third fa-spin"  *ngIf="(service.lastPublishDate || service.lastPublishedWhen) && !service.publishHistory"></i>
																<strong  tooltip="{{'Release notes' | translate}}"  *ngIf="(service.lastPublishDate || service.lastPublishedWhen) && service.publishHistory"
																	placement="right"
																	container="body"
																	(click)="openRCList(service)"
																	container="body" class="item-date">{{ service.version }}</strong>
															</div>
														</div>
														<ng-container *ngIf="service.showExternalinList">
															<div class="row align-centent-center flex-grow-1 t-bordered py-2" *ngFor="let stat of service.statusesInExternalServers">
																<div class="col-4 align-items-center d-flex">
																	<ng-container *ngIf="service.active && ((service.lastPublishDate || service.lastPublishedWhen) && service.publishHistory)">
																		<a href="#"
																			tooltip="{{'See service' | translate}}"
																			placement="right"
																			container="body"
																			(click)="goSeeService(service, stat.externalServer.host); $event.preventDefault();"
																			class="badge badge-primary-light mr-2">
																			{{stat.externalServer.address || stat.externalServer.name}}
																		</a>
																		<i class="fal fa-link-simple ml-auto mr-4 icon-faded"
																			tooltip="{{'Copy Service link' | translate}}"
																			placement="right"
																			container="body"
																			(click)="goSeeService(service, stat.externalServer.host, true); $event.preventDefault();" style="font-size:0.9rem"></i>
																	</ng-container>
																</div>
																<div class="col-2 align-items-center d-flex justify-content-center">
																	<a (click)="toggleOperational(service, stat); $event.stopPropagation()"
																		class="{{ showIconFor(stat) }}" aria-hidden="true" tooltip="{{ 'Toggle activation' | translate }}"></a>
																</div>
																<div class="col-4 align-items-center d-flex text-center">
																	<div class="row align-items-center flex-nowrap  publish-row">
																		<div class="col-auto d-flex flex-row mb-0 milli text-left align-items-center pr-0 pl-1">
																			<times-popover [item]="service"></times-popover>
																		</div>
																		<div class="col d-flex flex-column mb-0 milli text-left px-0">
																			<ng-container *ngIf="stat.lastPublish?.date">
																				<span class="item-author">{{
																					stat.lastPublisher
																					}}</span>
																				<strong class="item-date" placement="right" container="body" 
																					tooltip="{{(stat.lastPublish?.date) | date: 'H:mm:ss'}}">{{
																					(stat.lastPublish?.date) | date: 'dd-MM-yyyy'
																				}}</strong>
																			</ng-container>
																		</div>
																	</div>
																</div>
																<div class="col-2 align-items-center d-flex text-center">
			
																</div>
															</div>
														</ng-container>
													</div>
													<div class="col-2 align-items-center justify-content-end d-flex py-2">
														<business-key *ngIf="service.businessKey" class="mr-auto"
															[businessKey]="service.businessKey"
															[businessKeyTooltip]="'Service business key' | translate"
															[extraClass]="'mr-2'"> </business-key>
														<i *ngIf="!service.active && !service.archived" class="far fa-box-archive btn-xs btn-bordered  btn-icon item-remove simple-icon mr-1 {{service.isMyAccountPage ? 'invisible' : ''}}"
															(click)="archiveService(service); $event.stopPropagation()" tooltip=" {{'Archive service' | translate}}"></i>
														<i *ngIf="service.archived" class="far fa-boxes-packing btn-xs btn-bordered btn-icon simple-icon item-remove mr-1 {{service.isMyAccountPage ? 'invisible' : ''}}"
															(click)="archiveService(service); $event.stopPropagation()" tooltip=" {{'Unarchive service' | translate}}"></i>
														<i class="far fa-arrow-up-from-line btn-xs btn-bordered btn-icon item-remove simple-icon mr-1 {{service.isMyAccountPage ? 'invisible' : ''}}"
															(click)="openExport(service); $event.stopPropagation()" tooltip=" {{'Export service' | translate}}"></i>
														<i class="far fa-cog btn-xs btn-bordered btn-icon item-remove simple-icon mr-1"
															(click)="openEdit(service); $event.stopPropagation()" tooltip=" {{'Service settings' | translate}}"></i>
														<confirmation-popover
																className="fas fa-times btn-xs btn-bordered btn-danger btn-icon item-remove {{service.isMyAccountPage ? 'invisible' : ''}}"
																(onConfirmed)="deleteService(service)"></confirmation-popover>
													</div>
												</div>
											</ng-container>
										</div>
										</ng-container>
										<div *ngIf="dragInProgress && group.status && (!group.services || !group.services.length)" class="empty-drop-hint">
											{{ 'Drop a service here' | translate }}
										</div>
									</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					
				</div>
			</div>
		</div>
	</div>
</div>

<drawer [title]="'Download'"
        [contextLabel]="selectedService?.name"
        [contextVariant]="'neutral'"
        (saveEvent)="initCopy();"
        [saveLabel]="'Download'"
        [isClosed]="!showCopyServiceModal"
        (closeEvent)="closeExport()" *ngIf="selectedService">
	<service-copy-modal [serviceName]="selectedService.name" [serviceId]="selectedService.id" (formSubmit)="downloadServiceJson($event, selectedService)"></service-copy-modal>
</drawer>

<drawer [title]="newService?.id ? 'Edit service' : 'Add new service'"
        [contextLabel]="newService?.id ? (newService?.name || newService?.businessKey) : null"
        [contextVariant]="'neutral'"
        [isClosed]="false" (saveEvent)="saveServiceAdd()" (closeEvent)="closeAdd()" *ngIf="showAddComponent">
	<service-add
		class="drawer-layer-content"
		[service]="newService"
		[services]="services"
		(cancel)="closeAdd()"
		(formSubmit)="serviceFromSlider($event)">
	</service-add>
</drawer>

<drawer *ngIf="selectedReleaseNotes && showReleaseNotes"
        [showHeaderButtons]="false"
        [title]="selectedReleaseNotes.name"
        [contextLabel]="'Release notes'"
        [contextVariant]="'info'"
        [isClosed]="!showReleaseNotes" (closeEvent)="closeRNdrawer();">
	<release-notes-list [releases]="selectedReleaseNotes.publishHistory" [service]="selectedReleaseNotes"></release-notes-list>
  </drawer>
